import React from 'react';
import BrandDetail from '../components/BrandDetail';

const Lumen = () => {
  return <BrandDetail brandSlug="lumen" />;
};

export default Lumen;
